import React,{ useRef, useEffect } from 'react'
import { Link } from 'react-router-dom';
import SkillCard from './SkillCard';
import ButtonComp from './ButtonComp';
import ReactHtmlParser from 'react-html-parser';

const SkillAreas = ({skillAreaTitle,skillSubtitle,TopMiddleSection,lifestyleCards,background,color,btnText,className,leftSection=true,skillBottomtitle,btnText2,btnLink2,MiddleInfoSection,highlitedBackground,btnLink="/auth/register",skillToptitle}) => {
  const scrollRef = useRef(null);

  useEffect(() => {
    const slider = scrollRef.current;
    if (!slider) return;
    let isDown = false;
    let startX;
    let scrollLeft;

    const handleMouseDown = (e) => {
      isDown = true;
      slider.classList.add("active");
      startX = e.pageX - slider.offsetLeft;
      scrollLeft = slider.scrollLeft;
    };

    const handleMouseLeave = () => {
      isDown = false;
      slider.classList.remove("active");
    };

    const handleMouseUp = () => {
      isDown = false;
      slider.classList.remove("active");
    };

    const handleMouseMove = (e) => {
      if (!isDown) return;
      e.preventDefault();
      const x = e.pageX - slider.offsetLeft;
      const walk = (x - startX) * 2; // scroll speed
      slider.scrollLeft = scrollLeft - walk;
    };

    // Touch support
    const handleTouchStart = (e) => {
      startX = e.touches[0].pageX;
      scrollLeft = slider.scrollLeft;
    };

    const handleTouchMove = (e) => {
      const x = e.touches[0].pageX;
      const walk = (x - startX) * 2;
      slider.scrollLeft = scrollLeft - walk;
    };

    slider.addEventListener("mousedown", handleMouseDown);
    slider.addEventListener("mouseleave", handleMouseLeave);
    slider.addEventListener("mouseup", handleMouseUp);
    slider.addEventListener("mousemove", handleMouseMove);

    slider.addEventListener("touchstart", handleTouchStart);
    slider.addEventListener("touchmove", handleTouchMove);

    return () => {
      slider.removeEventListener("mousedown", handleMouseDown);
      slider.removeEventListener("mouseleave", handleMouseLeave);
      slider.removeEventListener("mouseup", handleMouseUp);
      slider.removeEventListener("mousemove", handleMouseMove);

      slider.removeEventListener("touchstart", handleTouchStart);
      slider.removeEventListener("touchmove", handleTouchMove);
    };
  }, []);

  return (
    <div className={`why-choosing-skill np-busy-lifestyle ${className}`} id='skill-area'
    style={{
        background:`${background ? background : "linear-gradient(180deg, #0D1830 29.33%, #0D1830 64.9%, #7F56D9 100%)"}`,
        color:`${color ? color : "white"}`
    }}
    >
         <div className="custom-container">
       
           {/* HEADER */}
           {/* <div className="row align-items-center mb-5"> */}
           <div className="d-flex flex-column flex-lg-row justify-content-between w-100 mb-5 gap-4">
              <div className={leftSection ? "w-100 w-lg-50" : "w-100"}> {skillAreaTitle && skillAreaTitle()}
            </div> 
            {
              leftSection && (
              <div className="w-100 w-lg-40 d-flex flex-column gap-3">
              { skillSubtitle && <p className={`skill-title sub-title ${color ? color : "white"}`}>
                  {ReactHtmlParser(skillSubtitle)}
                </p>
               }
               { highlitedBackground && <div className='academy-highlight-box FS16FW500 mt-3 mb-4' >{highlitedBackground}</div> }
              {btnText &&  <ButtonComp link={btnLink} btnText={btnText}/>}
             </div>
       
              )
            }
         
           </div> 

            <div className="align-items-center d-flex flex-column gap-4 FS16FW500 my-4">
               {skillToptitle && <p className={`skill-title sub-title ${color ? color : "white"}`}>
                {skillToptitle}
               </p>}
          </div>
           {TopMiddleSection && TopMiddleSection()}
       
           {/* CARDS */}
           <div className="row flex-nowrap overflow-auto g-4 scroll-row" ref={scrollRef}>
       
             {lifestyleCards.map((card, index) => (
              <SkillCard card={card} index={index} color={color}/>
             ))}
       
           </div>
           {MiddleInfoSection && 
            <div className="row g-3 mt-3 plus-sans FS16FW500 fw-400">
              {MiddleInfoSection.map((item, i) => (
                <div key={i} className="col-lg-6 col-md-6">
                  <div className="info-pill h-100">
                    {item}
                  </div>
                </div>
              ))}
            </div>
           }
         <div className="align-items-center d-flex flex-column gap-4 FS16FW500 mt-4">
               {skillBottomtitle && <p className={`skill-title sub-title ${color ? color : "white"}`}>
                {skillBottomtitle}
               </p>}
              {btnText2 &&  <ButtonComp link={btnLink2 || "/auth/register"} btnText={btnText2}/>}
          </div>
          </div>
         </div>
  )
}

export default SkillAreas
